import translationEN from '../../assets/locales/en/translation.json';
import translationFR from "../../assets/locales/fr/translation.json";
import translationPL from "../../assets/locales/pl/translation.json";

import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { enqueueSnackbar } from 'notistack';
import {State} from '../../components/grid/BasicGridState'

import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'flatpickr/dist/flatpickr.min.css';

import '../../components/grid/styles.scss';
import '../../components/grid/slickgrid.scss';
import '../../layouts/gridlayout.css'
import i18next, { TFunction } from 'i18next';

import UserService from "../../services/user/user.service";
import { ColorEditor } from '../../components/grid/CustomEditors/ColorEditor';

import {
   SlickgridReact, FieldType, Filters,
   GridOption,
  Column, Formatter, Formatters,
  Editors, EditCommand, 
  CompositeEditorModalType, OnCompositeEditorChangeEventArgs, CompositeEditorSelection,
  InputEditor,
  SlickGrid,
  OnAddNewRowEventArgs,
  EditorValidator,
  CurrentSorter,
  EmitterType,
} from 'slickgrid-react';

import { ExcelExportService } from '@slickgrid-universal/excel-export';
import { OdataOption, OdataServiceApi } from '@slickgrid-universal/odata';


import BaseGrid, {BasicGridProps} from '../../components/grid/BaseGridComponent';
import { TextOperators } from '../../components/grid/CustomFilters/TextFilter';
import { SlickCustomTooltip } from '@slickgrid-universal/custom-tooltip-plugin';
import authService from '../../services/auth/auth.service';
import userService from '../../services/user/user.service';
import { LookupCollection, LookupData } from '../../components/grid/GridUtils';

import { withTranslation } from 'react-i18next';
import { InputAdornment, TextField } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import BorderSpinner from '../../components/Layout/spinner';


const location = window.location
  
const locationley = location.pathname.replace('/', '')
const LOCAL_STORAGE_SEARCH = authService.getCurrentUser()?.shrt + '_crm-' + locationley + '-search' 

const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  },
  pl: {
    translation: translationPL
  }
};


class User extends BaseGrid {
  
    title = 'Użytkownicy';
    subTitle = 'Zarządzanie użytownikami'
   //props : BasicGridProps=
 constructor(public readonly props: BasicGridProps) {
    //var p:BasicGridProps={ storage_key :  LOCAL_STORAGE_KEY, auto_edit_key : LOCAL_STORAGE_AUTO_EDIT}
    //props={...props, storage_key :  LOCAL_STORAGE_KEY, auto_edit_key : LOCAL_STORAGE_AUTO_EDIT}
    super(props);
   
    
 }

 //taskTranslateFormatter: Formatter = (_row, _cell, value, _columnDef, _dataContext, grid) => {
  //const gridOptions = grid.getOptions() as GridOption;

  //return gridOptions.i18n?.t('COLUMN_RESIZE_BY_CONTENT', { x: value }) ?? '';
//};


setSearchFilter() {
  if (this.reactGrid && localStorage[this.search_key] && localStorage[this.search_key]!==''){
    this.reactGrid.filterService.updateFilters([])
    //this.reactGrid.backendService?.buildQuery('firstname=SA')
  /*  this.reactGrid.filterService.updateFilters([
      { columnId: 'shortcut', searchTerms: [localStorage[this.search_key]], operator: 'NOT_IN' },
      { columnId: 'firstname', searchTerms: [localStorage[this.search_key]], operator: 'NOT_IN' },
      { columnId: 'surname', searchTerms: [localStorage[this.search_key]], operator: 'NOT_IN' },
      { columnId: 'mail', searchTerms: [localStorage[this.search_key]], operator: 'NOT_IN' },
      { columnId: 'phone', searchTerms: [localStorage[this.search_key]], operator: 'NOT_IN' }
    ]);*/
  }else{
    if (this.reactGrid){
       this.reactGrid.filterService.clearFilters()
    }
  }
}

  
onStorage = () => {
  this.setSearchFilter()
  
};
onFocus = () => {
  window.addEventListener("storage", this.onStorage)
};
onBlur = () => {
  window.removeEventListener("storage", this.onStorage)
};
  
componentDidMount() {
    window.addEventListener("resize",((e: any) =>{
      setTimeout(() => { this.reactGrid.resizerService.resizeGrid(); }, 1000);
      
  }).bind(this));

  window.addEventListener("focus", this.onFocus);
  window.addEventListener("blur", this.onBlur);
  this.onFocus();

  this.getusergrouplookup();
    i18next.init({
      lng: 'pl',
      debug: false,
      resources: resources
    }, (err, t) => {
      i18next.changeLanguage("pl");
      
    });
  
}

//componentDidUnmount() {
 //window.removeEventListener('storage', handleStorage)
//}

 defineGrid() {
    var presets = JSON.parse(localStorage[this.storage_key] || null);

    if (presets){
      var new_sorters = presets.sorters.map((element: CurrentSorter) => {
        element.columnId = (element.columnId as string).toLowerCase();
        return element;
      });
      presets.sorters = new_sorters;
    }
   
    var gridOptions =  this.getGridDefinition();
    gridOptions.presets = presets

    var columnDefinitions = this.getColumnDefinitions();

    this.setState((state: State) => ({
      ...state,
      gridOptions:gridOptions,
      columnDefinitions:columnDefinitions,
    
  }));
}

componentDidUpdate(PrevProps: any, prevState: State){
  if(this.state.alertErrorMsg !== prevState.alertErrorMsg){
      if (this.state.alertErrorMsg){
       // alert(this.state.alertErrorMsg)
      }
  }   
  
}


  getGridDefinition(): GridOption {    
      var tmp = super.getGridDefinition(this.state);
      tmp = {
        ...tmp,
        enableTranslate: true,
        i18n: i18next,
        autoResize: {
          container: '#smaller-container',
          rightPadding: 10
        },
        //columnPicker:{}
        enableExcelExport : true,
        excelExportOptions: {
          sanitizeDataExport: true
        },
        externalResources: [this.excelExportService, this.compositeEditorInstance, new SlickCustomTooltip()],
        
        editCommandHandler: (_item:any, _column:Column<any>, editCommand:EditCommand) => {
          var data = _item
         // if (editCommand.editor instanceof  InputEditor){
         //   data[_column.field] = editCommand.serializedValue
         // }  
  
          this._commandQueue.push(editCommand);
          editCommand.execute();
          this.editUserApiCall(data);
        },
        presets: {},
        
        backendServiceApi: {
          ...tmp.backendServiceApi,
          onError: (error: Error) => {
              this.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertError: "Błąd połączenia!"
              }));  
          },
          preProcess: () => {
            this.setState((state: State) => ({ ...state, errorStatus: '' }));
            this.displaySpinner(true);
          },
          process: (query) => {
            if (localStorage[this.search_key] && localStorage[this.search_key]!=''){
              query=query + "&$search=" + localStorage[this.search_key].replace('&', 'i') 
            }
            return this.getUserApiCall(query)},
          postProcess: (response) => {
            this.setState(
              (state: State) => ({ ...state, metrics: response.metrics }),
              () => this.postProcessCallback(response)
            );
            this.displaySpinner(false);
          },
        } as OdataServiceApi
      }
    return tmp;
  }

  onCellValidationError(_e: Event, args: any) {
    if (args.validationResults) {
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertWarning: args.validationResults.msg
      }));
    }
  }



  shortcutValidator :EditorValidator = (value: any) => {
    
    let ready=false
    if (value === null || value === undefined || !value.length) {
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertErrorMsg: []
      }));
      return { valid: false, msg: 'To pole jest wymagane' };
    }else if (value.length>3) {
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertErrorMsg: []
      }));
      return {
        valid: false,
        msg: 'To pole przyjmuje maksymalnie 3 znaki',
      };

    }else{
      var selectRow =this.reactGrid.slickGrid.getSelectedRows();
      var id=-1
      if (selectRow.length ==1){
        if (this.reactGrid.slickGrid.getDataItem(selectRow[0])){
          id = this.reactGrid.slickGrid.getDataItem(selectRow[0]).id
        }
      }
       UserService.userExist(value, id).then(response => {
            if (response >0){
              
              this.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertError: "Identyfikator użytkownika: " + value + " już istnieje!",
                //alertErrorMsg: "Identyfikator użytkownika: " + value + " już istnieje!"
              }));
          
            }else{
              this.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertErrorMsg: []
              }));
            }
      }
      ).catch(
        (error) => {
          this.setState((state: State, props: BasicGridProps) => ({
            ...state,
            alertError: error
      }));
        }
      )
    }
   
    return { valid: true, msg: '' };
  };

  requiredNameValidator: EditorValidator = (value: any) => {
    if (value === null || value === undefined || !value.length) {
      return { valid: false, msg: 'To pole jest wymagane' };
    } else if (value.length>100) {
      return {
        valid: false,
        msg: 'To pole przyjmuje maksymalnie 3 znaki',
      };
    }
    return { valid: true, msg: '' };
  };

  requiredIntValidator: EditorValidator = (value: any) => {
    if (value === null || value === undefined) {
      return { valid: false, msg: 'To pole jest wymagane' };
    } 
    return { valid: true, msg: '' };
  };

  requiredValidator: EditorValidator = (value: any) => {
    if (value === null || value === undefined || !value.length) {
      return { valid: false, msg: 'To pole jest wymagane' };
    } 
    return { valid: true, msg: '' };
  };

  phoneValidator: EditorValidator = (value: any) => {

    if (value.length>100) {
      return {
        valid: false,
        msg: 'To pole przyjmuje maksymalnie 100 znaków',
      };
    }else if (/[a-zA-Z]+/.test(value)){
      return { valid: false, msg: 'Numer telefonu nie może zawierać liter [a-z A-Z]' };
    }
    return { valid: true, msg: '' };
  };

  emailValidator: EditorValidator = (value: any) => {
    if (value === null || value === undefined || !value.length) {
      return { valid: false, msg: 'To pole jest wymagane' };
    }else{
      if (value.length>100) {
        return {
          valid: false,
          msg: 'To pole przyjmuje maksymalnie 100 znaków',
        };
      }else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,8}$/.test(value)){
        return { valid: false, msg: 'Nieprawidłowy format adresu e-mail' };
      }
    } 
    return { valid: true, msg: '' };
  };

  getusergrouplookup(){
    return userService.getusergrouplookup().then(response => {
       let tmp : LookupData[] = [];
        if ((response.data) && (Array.isArray(response.data) && (response.data[0].name=='usergroup'))){
            let tmp1 :LookupCollection = response.data[0]
        
            this.setState((state: State) => ({
              ...state,
              lookupData : [tmp1]
            }),  () => this.defineGrid()
        
        );
      }
    }
       
    ).catch(
      () => {
        let tmp : LookupData[] = [];
        this.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertError: "Nie wszystkie dane zostały poprawnie zaczytane - odśwież stronę!"
        }));
        return tmp;
      }
    )
  }

  getColumnDefinitions(): Column[] {
    //super.getColumnDefinitions()
    let tmp : Column[] = [];
    let data: any[] = [];
    this.state.lookupData?.forEach((item) => {
      if (item.name === 'usergroup'){
         data = item.data; 
      } 
    });

    if (authService.isAdmin()){
      tmp.push(
        {
          id: 'delete', field: 'id',
          excludeFromColumnPicker: true, excludeFromGridMenu: true,excludeFromHeaderMenu: true,
          formatter: Formatters.icon, params: { iconCssClass: 'fa fa-trash pointer' }, minWidth: 30, maxWidth: 30,  
          customTooltip: {
            formatter:  this.deleteUserFormatter.bind(this) as Formatter
          },    
        }
      );
    }

    if (authService.isAdmin()) {
      tmp.push(
        {
          id: 'setpassword', field: 'id',
          excludeFromColumnPicker: true, excludeFromGridMenu: true,excludeFromHeaderMenu: true,
          formatter: Formatters.icon, params: { iconCssClass: 'fa fa-key pointer' }, minWidth: 30, maxWidth: 30,   
          customTooltip: {
            formatter:  this.setPasswordFormatter.bind(this) as Formatter
          },
          
        },
      );
    }
    tmp.push(
      {
        id: 'row_no', name: 'Lp.', field: 'row_no', sortable: false, filterable: false,
        type: FieldType.integer,
        minWidth:30 ,
        maxWidth:50    
      },
        {
          id: 'shortcut', name: 'Skrót', field: 'shortcut', sortable: true, filterable: true,
          excludeFromColumnPicker: true,
          type: FieldType.string,
          //formatter:this.taskTranslateFormatter,
          filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
          editor: {model: Editors.text,
            validator : this.shortcutValidator,
            maxLength:3,
            compositeEditorFormOrder : 1,
            
          },
          hidden:false,
          minWidth:100
               
        },
        {
          id: 'firstname', name: 'Imię', field: 'firstname', sortable: true, filterable: true,
          excludeFromColumnPicker: true,
          type: FieldType.string,
          filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
          editor: {model: Editors.text,
            validator : this.requiredNameValidator,
            maxLength:100,
            compositeEditorFormOrder : 2
          }, 
          minWidth:100     
        },
        {
          id: 'surname', name: 'Nazwisko', field: 'surname', sortable: true, filterable: true,
          excludeFromColumnPicker: true,
          type: FieldType.string,
          filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
          editor: {model: Editors.text,
            validator : this.requiredNameValidator,
            maxLength:100,
            compositeEditorFormOrder : 3        
          },
          minWidth:100
        },
        {
          id: 'mail', name: 'E-mail', field: 'mail', sortable: true, filterable: true,
          excludeFromColumnPicker: true,
          type: FieldType.string,
          filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
          editor: {model: Editors.text,
            validator : this.emailValidator,
            maxLength:100,
            compositeEditorFormOrder : 4
          },
          minWidth:100
        },
        {
          id: 'phone', name: 'Telefon', field: 'phone', sortable: true, filterable: true,
          type: FieldType.string,
          filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
          editor: {model: Editors.text,
            validator : this.phoneValidator,
            maxLength:100,
            compositeEditorFormOrder : 5
          },
          minWidth:100
        },
        {
          id: 'usergroup_name', name: 'Grupa', field: 'usergroup_name', sortable: true, filterable: true,
          type: FieldType.string,
          excludeFromColumnPicker: true,
          filter: {model: Filters.multipleSelect, collection:data, compoundOperatorList: TextOperators},
          editor: {model: Editors.singleSelect,
            validator : this.requiredValidator,
            collection: data,
            compositeEditorFormOrder : 6,
          },
          
          minWidth:100
        },
        {
          id: 'color', name: 'Kolor', field: 'color', sortable: false, filterable: false,
          type: FieldType.string, formatter: this.colorFormatter,
          editor: {model: ColorEditor,  massUpdate: false},
          minWidth:50
        },
         {
                id: 'reported', name: 'Raportowany', field: 'reported', sortable: true, filterable: true,
                type: FieldType.boolean,
                formatter: Formatters.checkmark,
                filter: {
                  model: Filters.singleSelect,
                  collection: [
                    { value: '', label: '' },
                    { value: 1, label: 'Tak' },
                    { value: 0, label: 'Nie' },
                  ],
                },
                editor: {model: Editors.checkbox,
                  compositeEditorFormOrder : 14,
                },
                
                minWidth:50
              },
              {
          id: 'panel_order', name: 'Nr porządkowy panelu', field: 'panel_order', sortable: true, filterable: true,
          type: FieldType.integer,
          editor: {model: Editors.integer, massUpdate: false},
          minWidth:50
        },
       
    );
    tmp = this.customizeHeaderMenu(tmp)
    return tmp
  }

  setPasswordFormatter(row: number, cell: number, value: any, column: Column, dataContext: any, grid: SlickGrid) {
    const tooltipTitle = 'Ustaw hasło';
    return `<div class="header-tooltip-title">${tooltipTitle}</div>
    <div class="tooltip-2cols-row"><div>Użytkownik:</div> <div>${dataContext.firstname} ${dataContext.surname}</div></div>`;
  }

  deleteUserFormatter(row: number, cell: number, value: any, column: Column, dataContext: any, grid: SlickGrid) {
    const tooltipTitle = 'Usuń';
    return `<div class="header-tooltip-title">${tooltipTitle}</div>
    <div class="tooltip-2cols-row"><div>Użytkownik:</div> <div>${dataContext.firstname} ${dataContext.surname}</div></div>`;
  }

  getUserApiCall(query: string) {
    return UserService.getusers(query)
  }
  editUserApiCall(data: any) {   
    UserService.edituser(data).then(
      
      ).catch(
         (error) => {
          try{
            this._commandQueue.pop()?.undo()
            this.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertError: "Błąd edycji danych"
            }));
          }catch{

          }
        }
      )
  }

  sortCollectionDescending(collection: any[]) {
    return collection.sort((item1, item2) => item1.value - item2.value);
  }

  openCompositeModal(modalType: CompositeEditorModalType) {
    let modalTitle = '';
    if (this.reactGrid.slickGrid.getEditorLock().isActive() && !this.reactGrid.slickGrid.getEditorLock().commitCurrentEdit()) {
      return;
    }
      switch (modalType) {
        case 'create':
          modalTitle = 'Dodawanie nowego użytkownika';
          break;
        case 'clone':
          modalTitle = 'Kopiowanie użytkownika - {{firstname} {surname}}';
          break;
        case 'edit':
          var selecttedcount =  this.reactGrid.slickGrid.getSelectedRows();
          if (selecttedcount.length > 1){
            modalTitle = 'Edycja wybranych rekordów (' + selecttedcount + ')';
            modalType = 'mass-selection';
          }else{
            modalTitle = 'Edycja użytkownika - (<span class="text-muted"></span><span class="text-primary">{{shortcut}}</span>)'; // 'Editing - {{title}} ({{product.itemName}})'
          }
          break;
      }
      var modalColumns = this.reactGrid.slickGrid.getColumns(). filter(col => col.editor);

    if (modalType==='edit'){
      if (this.reactGrid.slickGrid.getSelectedRows() && (this.reactGrid.slickGrid.getSelectedRows().length===1)){
        this.compositeEditorInstance?.openDetails({
          headerTitle: modalTitle,
          modalType,
          insertOptions: { highlightRow: false }, 
          showFormResetButton: true,
          resetFormButtonIconCssClass: 'fa fa-undo',
          
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
        });
      }else if (this.reactGrid.slickGrid.getSelectedRows() && (this.reactGrid.slickGrid.getSelectedRows().length>1)){
        alert('Wybież jednego użytkownika do edycji!');
      }else{
        alert('Nie wybrano użytkownika do edycji!');
      }
    }else{
        this.compositeEditorInstance?.openDetails({
            headerTitle: modalTitle,
            modalType,
            insertOptions: { highlightRow: false }, 
            showFormResetButton: true,
            resetFormButtonIconCssClass: 'fa fa-undo',
          
            
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
          onSave: (formValues, _selection: CompositeEditorSelection, dataContext) => {
            if (_selection.gridRowIndexes.length===0){
              let tmp = {...dataContext, id:null}
              if (tmp.panel_order==''){
                tmp.panel_order = null;
              }
              UserService.adduser(tmp).then(
                (data) => {
                  this.reactGrid.filterService.updateFilters([])
                }
                ).catch(
                  (error) => {
                    try{   
                      console.log(error)
                      if (error && error.response && error.response.data && error.response.data.detail){
                        this.setState((state: State, props: BasicGridProps) => ({
                          ...state,
                          alertError: "Błąd: " + error.response.data.detail
                        }));
                      }else{          
                        this.setState((state: State, props: BasicGridProps) => ({
                          ...state,
                          alertError: "Błąd podczas dodawania użytkownika"
                        }));
                      }
                      
                      var tmp = this.reactGrid.slickGrid.getData().getItems()
                      tmp.splice(0,1);
                      
                      this.reactGrid.slickGrid.getData().setItems(tmp)
                    }catch{
          
                    }
                  }
                )   
            }
          const serverResponseDelay = 50;
          return new Promise(resolve => setTimeout(() => resolve(true), serverResponseDelay));
        }
      });
    }
  }
    
  onCellClicked(_e: Event, args: any) {
    const metadata = this.reactGrid.gridService.getColumnFromEventArguments(args);

    if (metadata.columnDef.id === 'delete') {
      
      if (window.confirm('Czy potwierdzasz usunięcie użytkownika: ' + metadata.dataContext.firstname + ' ' + metadata.dataContext.surname + '?')) {
        userService.deleteuser(metadata.dataContext.id).then(
          () => {
            this.reactGrid.gridService.deleteItemById(metadata.dataContext.id)

            this.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertInfo: `Usunięto: ${metadata.dataContext.firstname} ${metadata.dataContext.surname}`,
            }));
        }

        ).catch(
          () => {
            this.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertError: `Wystąpił problem przy usuwaniu użytkownika: ${metadata.dataContext.firstname} ${metadata.dataContext.surname}`,
            }));
          }
        )
        
        
      }
    }else if (metadata.columnDef.id === 'setpassword') {
      
      window.location.href = '/changepassword?username=' + metadata.dataContext.mail

    }
  }

  checkItemIsEditable(dataContext: any, columnDef: Column, grid: SlickGrid) {
    const gridOptions = grid.getOptions() as GridOption;
    const hasEditor = columnDef.editor;
    const isGridEditable = gridOptions.editable;
    let isEditable = Boolean(isGridEditable && hasEditor);
  
    if (dataContext && columnDef && gridOptions?.editable) {
      isEditable = authService.isAdmin() || authService.getCurrentUser()?.sub === dataContext?.mail;
    }
    return isEditable;
  }

  handleonAddNewRow(_e: Event, args: OnAddNewRowEventArgs) {
     //return true;
  }

  handleOnCompositeEditorChange(_e: Event, args: OnCompositeEditorChangeEventArgs) {
    
  }

  handleOnBeforeEditCell(e: Event, args: any) {
    const { column, item, grid } = args;

    if (column && item && !this.checkItemIsEditable(item, column, grid)) {
      e.stopImmediatePropagation();
      return false;
    }
    return true;
  }

  resizeContent($event:any){
    alert('aaaa')
  }

  render() {
    if (this.state.alertWarning) {
      enqueueSnackbar(this.state.alertWarning, {variant: 'warning', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertWarning: ''
      }));
    }
    if (this.state.alertError) {
      enqueueSnackbar(this.state.alertError, {variant: 'error', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertError: ''
      }));
    }
   // console.log(this.state.alertErrorMsg)
    if (this.state.alertErrorMsg.length > 0){
      for (const msg in this.state.alertErrorMsg){
        enqueueSnackbar(msg, {variant: 'error', preventDuplicate: true, autoHideDuration:5000, persist: false})
      }
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertErrorMsg: []
      }));
    }

    if (this.state.alertInfo) {
      enqueueSnackbar(this.state.alertInfo, {variant: 'info', preventDuplicate: true, autoHideDuration:5000, persist: false}) 
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertInfo: ''
      }));
    }

    return !this.state.gridOptions ? '' : (
       <>
          <div className="gridMenu">
            <div className='gridLeftSubMenu'> 
              <FormControlLabel id="lblautoedit" control={<Switch checked={this.state.isAutoEdit} onChange={(_, data) => this.autoeditchange(data)}  />} label="Auto-edit" />

              
            </div>
            
            
            <div className='gridCenterSubMenu'>
            
           { authService.isAdmin() && <button className="btn btn-outline-secondary btn-sm mx" data-test="clear-sorting"
                  onClick={() => {this.openCompositeModal('create')} 
            }>
                  Dodaj
                </button>
            }
           
              
            <button className="btn btn-outline-secondary btn-sm mx-1" data-test="clear-sorting"
              onClick={() => this.openCompositeModal('edit')}>
                Edytuj
            </button>
              
            </div><div className='gridRightSubMenu'>
                <button className="btn btn-outline-secondary btn-sm mx-1" data-test="set-dynamic-sorting"
                  onClick={() => this.setFactorySettings()}>
                  Ustawienia domyślne
                </button>

              </div>
          </div>
          <div id="smaller-container" onResize={this.resizeContent} style={{ width: '100%' }}>
          {this.state.status.text =='loading' ? <BorderSpinner/> : ''}
          
          <SlickgridReact gridId="user-grid"
            columnDefinitions={this.state.columnDefinitions}
            gridOptions={this.state.gridOptions}
            dataset={this.state.dataset}
            paginationOptions={this.state.paginationOptions}
            onReactGridCreated={$event => this.reactGridReady($event.detail)}
            onGridStateChanged={$event => this.gridStateChanged($event.detail)}
            onClick={e => { this.onCellClicked(e.detail.eventData, e.detail.args); }}  
            onBeforeEditCell={$event => this.handleOnBeforeEditCell($event.detail.eventData, $event.detail.args)}   
            onCompositeEditorChange={$event => this.handleOnCompositeEditorChange($event.detail.eventData, $event.detail.args)}
            onAddNewRow={$event => this.handleonAddNewRow($event.detail.eventData, $event.detail.args)}
            onValidationError={e => { this.onCellValidationError(e.detail.eventData, e.detail.args); }}
            
            
          />
          </div>
      </>
    );
  }
}

export default withTranslation()(User);